import Api from './Api';

class Base extends Api {
  async get(params) {
    const { data: { data } } = await super.get(params);
    return data;
  }

  async getUrl(url, params) {
    const { data: { data } } = await super.getUrl(url, params);
    return data;
  }

  async getById(id, params) {
    const { data: { data } } = await super.getById(id, params);
    return data;
  }

  async save(data, url) {
    const { data: { data: res } } = await super.save(data, url);
    return res;
  }
}

export default Base;



// WEBPACK FOOTER //
// ./src/services/providers/Common/index.js